import React, { useContext, useEffect } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { TextBody } from './style';
import Title from '../../components/Title';
import PrivacyContext from '../../contexts/PrivacyContext';
import ErrorPage from '../ErrorPage';
import { createSafeHtml } from '../../utils/sanitizeHtml';

const Privacy = () => {
  const { header, privacy, error } = useContext(PrivacyContext);

  useEffect(() => {
    document.title = "DFS | Privacy";
  });

  return error ? (
    <ErrorPage />
  ) : (
    <Container>
      <Row>
        <Col tabIndex="0" className="skip-nav-focus">
          <Title>{header}</Title>
          <TextBody dangerouslySetInnerHTML={createSafeHtml(privacy)} />
        </Col>
      </Row>
    </Container>
  );
};

export default Privacy;